import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { observer } from "mobx-react-lite";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";

export const Notifier = observer(() => {
  const { notifier } = uiStore;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (notifier.message) {
      const action = notifier.action ? notifier.action(closeSnackbar) : undefined;
      enqueueSnackbar(notifier.message, { autoHideDuration: 3000, ...notifier.options, action });
    }
  }, [enqueueSnackbar, notifier]);

  return null;
});
